import { render, staticRenderFns } from "./RevenueAndProfitStackedPeriodChart.vue?vue&type=template&id=1933345a&scoped=true&"
import script from "./RevenueAndProfitStackedPeriodChart.vue?vue&type=script&lang=js&"
export * from "./RevenueAndProfitStackedPeriodChart.vue?vue&type=script&lang=js&"
import style0 from "./RevenueAndProfitStackedPeriodChart.vue?vue&type=style&index=0&id=1933345a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1933345a",
  null
  
)

component.options.__file = "RevenueAndProfitStackedPeriodChart.vue"
export default component.exports